import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import UploadDocumentModal from "./uploadModal";
import { t } from "i18next";
import { Tooltip } from "antd";

const UploadDocument = ({
    layout,
    values,
    errors,
    handleBlur,
    touched,
    setFieldValue,
    fileInputRef,
    initialState,
    sectionRefs,
    highlightField,
}) => {
    const [openModal, setOpenModal] = useState(false);
    const [activeProofField, setActiveProofField] = useState("");
    const handleClose = () => {
        setOpenModal(false);
    };

    return (
        <div className='relative rounded-md overflow-clip w-full h-full min-h-[200px] bg-white'>
            <div className='grid grid-cols-2 place-items-center bg-MetallicBlue px-10 py-3 text-white'>
                <div className='w-full py-1.5'>
                    <p className=''>{t(layout.title)}</p>
                </div>
            </div>

            <UploadDocumentModal
                open={openModal}
                handleClose={handleClose}
                values={values}
                errors={errors}
                handleBlur={handleBlur}
                touched={touched}
                setFieldValue={setFieldValue}
                fileInputRef={fileInputRef}
                activeProofField={activeProofField}
            />
            {Object.values(layout.doc_types).map((config) => {
                const isPOA = config.doc_upload_proof === "poaUploadProof";
                const isPOI = config.doc_upload_proof === "poiUploadProof";

                const isLocationChanged =
                    initialState?.region !== values.region ||
                    initialState?.zone !== values.zone ||
                    initialState?.woreda !== values.woreda;

                const isIdentityChanged =
                    initialState?.fullnameEng !== values.fullnameEng ||
                    initialState?.fullnameAmh !== values.fullnameAmh ||
                    initialState?.nationality !== values.nationality ||
                    initialState?.dateOfBirth !== values.dateOfBirth;

                // const shouldHighlight =
                // (isIdentityChanged && isPOI) ||
                // (isLocationChanged && isPOA);
                const isHighlighted =
                    highlightField === config.doc_upload_proof;

                const enableSection =
                    (isPOA && isLocationChanged) ||
                    (isPOI && isIdentityChanged);

                return (
                    <div
                        className='relative rounded-md overflow-clip w-full min-h-[150px] bg-white flex flex-col gap-3 py-2 px-4'
                        ref={(el) => {
                            sectionRefs.current[config.doc_upload_proof] = el;
                        }}
                    >
                        <p className='text-lg'>{t(config.doc_type_title)}</p>
                        <Tooltip
                            title={
                                isPOA
                                    ? t("tooltip-document-type-address")
                                    : isPOI
                                    ? t("tooltip-document-type-identity")
                                    : ""
                            }
                        >
                            <select
                                className={`py-1.5 px-3 w-full hover:cursor-pointer border-2 ${
                                    isHighlighted
                                        ? "text-blue-700 font-semibold animate-pulse ring-2 ring-blue-400 ring-offset-2 rounded px-2"
                                        : ""
                                }`}
                                value={values[config.doc_type]}
                                onChange={(e) =>
                                    setFieldValue(
                                        config.doc_type,
                                        e.target.value
                                    )
                                }
                                disabled={!enableSection}
                            >
                                <option value=''>
                                    {t(config.doc_selection)}
                                </option>
                                {config.doc_type_data.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </Tooltip>
                        {touched[config.doc_type] &&
                            errors[config.doc_type] && (
                                <p className='text-red-500'>
                                    {errors[config.doc_type]}
                                </p>
                            )}

                        <div className='relative w-full'>
                            <Tooltip
                                title={t(
                                    "Please select a document type before uploading."
                                )}
                            >
                                <button
                                    type='button'
                                    onClick={() => {
                                        setActiveProofField(
                                            config.doc_upload_proof
                                        );
                                        setOpenModal(true);
                                    }}
                                    className='bg-[#ffb400] w-full rounded-md py-5 flex items-center justify-center gap-2'
                                    disabled={!enableSection}
                                >
                                    <div className='w-fit h-fit p-3 bg-white rounded-full'>
                                        <FaPlus />
                                    </div>
                                    <p className='font-bold text-2xl'>
                                        {t(config.doc_button_title)}
                                    </p>
                                </button>
                            </Tooltip>
                        </div>

                        <div className='w-full py-1.5 text-center'>
                            <p className='italic'>
                                {t("document-upload-format")}
                                <span className='text-red-500 ml-1'>*</span>
                            </p>
                        </div>

                        {touched[config.doc_upload_proof] &&
                            errors[config.doc_upload_proof] && (
                                <p className='text-red-500'>
                                    {errors[config.doc_upload_proof]}
                                </p>
                            )}
                    </div>
                );
            })}
        </div>
    );
};

export default UploadDocument;
